import { CommandAlreadyExistsError } from './CommandAlreadyExistsError';
import { CommandHasAlreadyBeenTouchedError } from './CommandHasAlreadyBeenTouchedError';
import { CompilerError } from './CompilerError';
import { InvalidLicenseError } from './InvalidLicenseError';
import { MustContainFunctionError } from './MustContainFunctionError';
import { MustExtendAppError } from './MustExtendAppError';
import { NotEnoughMethodArgumentsError } from './NotEnoughMethodArgumentsError';
import { PathAlreadyExistsError } from './PathAlreadyExistsError';
import { RequiredApiVersionError } from './RequiredApiVersionError';
import { VideoConfProviderAlreadyExistsError } from './VideoConfProviderAlreadyExistsError';
import { VideoConfProviderNotRegisteredError } from './VideoConfProviderNotRegisteredError';

export {
    CommandAlreadyExistsError,
    CommandHasAlreadyBeenTouchedError,
    PathAlreadyExistsError,
    CompilerError,
    MustContainFunctionError,
    MustExtendAppError,
    NotEnoughMethodArgumentsError,
    RequiredApiVersionError,
    InvalidLicenseError,
    VideoConfProviderAlreadyExistsError,
    VideoConfProviderNotRegisteredError,
};
